import React from "react";
import { Link } from "gatsby";
import Layout from "../components/organisms/Layout";
import styled from "styled-components";
import loginBg from "../assets/images/login-bg.png";
import { StaticImage } from "gatsby-plugin-image";
import { AiOutlineMail } from "react-icons/ai";
import { BiKey } from "react-icons/bi";

import fb from '../assets/images/fb.png'
import google from '../assets/images/gmail.png'

const login = () => {
	return (
		<Layout>
			<Wrapper className='user-account login-form'>
				<div className='container'>
					<div className='row justify-content-center'>
						<div className='col-md-8 col-lg-7 col-xl-6'>
							<h1>¡Bienvenido nuevamente!</h1>
							<div className='card'>
								<div className='card-body'>
									<h4 className='text-center'>
										Accede con tu cuenta y disfruta.
									</h4>
									<form>
										<div className='row justify-content-center'>
											<div className='col-md-10 col-lg-8'>
												<div className='form-group'>
													<input
														type='email'
														className='form-control'
														placeholder='Correo electrónico'
													/>
													<i>
														<AiOutlineMail style={{ marginTop: "-10px" }} />
													</i>
												</div>
												<div className='form-group mb-2'>
													<input
														type='password'
														className='form-control'
														placeholder='Contraseña'
													/>
													<i>
														<BiKey style={{ marginTop: "-10px" }} />
													</i>
												</div>
												<Link
													to='/recover-password'
													className='text-right d-block forgot-pass'>
													¿Olvidaste tu contraseña?
												</Link>
												<div className='row align-items-center my-4'>
													<div className='col-sm-5 text-center text-sm-left order-2 order-sm-1'>
														<Link to='/register' className='link'>
															Regístrate
														</Link>
													</div>
													<div className='col-sm-7 text-center text-sm-right order-1 order-sm-2'>
														<button
															type='submit'
															className='btn btn-warning mb-3 mb-sm-0'>
															Iniciar sesión
														</button>
													</div>
												</div>
												<hr />
												<p className='text-center'>O accede por medio de</p>
												<p className='text-center'>
													<a href='https://facebook.com' target={"_blank"}>
														<img
															className='mr-3'
															width='45'
															src={fb}
															alt='fb'
														/>
													</a>
													<a href='https://google.com' target='_blank'>
														<img
															width='45'
															src={google}
															alt='fb'
														/>
													</a>
												</p>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</Wrapper>
		</Layout>
	);
};

export default login;

const Wrapper = styled.section`
	background-image: linear-gradient(rgb(11 10 10 / 0%), #5268c2ba),
		url(${loginBg});
`;
